export const environment = {
  production: true,

  apiUrl: 'https://api.esrnm.com/api/Web/',
  apiUrl2: 'https://api.esrnm.com/api/',

  imageUrl: 'https://api.esrnm.com/',
  DashboardLink: 'https://admin.esrnm.com',
  returnedUrl: 'https://esrnm.com/'


}